export default{
    lista:{
        method:'get',
        url:'comissionado/lista'
    },
    listatrabalhador:{
        method:'get',
        url:'trabalhador/pesquisa{/id}'
    },
    listatomador:{
        method:'get',
        url:'tomador/pesquisa{/id}'
    },
    cadastra:{
        method:'post',
        url:'configuracao/cadastro'
    },
    delete:{
        method:'delete',
        url:'configuracao/deletar{/id}'
    },
    editar:{
        method:'get',
        url:'configuracao/editar{/id}'
    },
    update:{
        method:'post',
        url:'configuracao/update'
    }
}